const open = ( url, options = {}) => {
  if ( !url ) return;

  if ( options.event?.ctrlKey || options.event?.metaKey ) {
    window.open( url );
  } else {
    window.location.href = url;
  }
};

export const URLOpener = { open };
